/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var StarIcon20Solid = forwardRef('StarIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9.139 1.7c.325-.756 1.397-.756 1.722 0l2.03 4.713 5.11.474c.819.076 1.15 1.095.532 1.637l-3.856 3.387 1.129 5.006c.18.803-.686 1.433-1.394 1.013L10 15.31l-4.412 2.62c-.708.42-1.575-.21-1.394-1.013l1.129-5.006-3.856-3.387C.85 7.981 1.18 6.963 2 6.887l5.11-.474L9.14 1.7Z" })));
});
